import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
// import { useGetAllDevisesQuery } from "../../app/services/deviseApi";

function CoursCard(props) {
  const navigate = useNavigate();
  return (
    <Box
      // maxWidth="xl"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ffffff",
        alignItems: "center", // Centrer les éléments horizontalement
        justifyContent: "start", // Centrer les éléments verticalement
        pt: { xs: 1, sm: 2 },
        pb: { xs: 1, sm: 2 },
        minHeight: "100vh", // Hauteur minimum de 100% de la page
      }}
    >


<Card
  sx={{
    width: '100%',
    backgroundColor: '#ffeb3b',
    p: 2,
    boxShadow: 3,
    mb: 3,
  }}
>
  <CardContent
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' }, // colonne en mobile, ligne en desktop
      justifyContent: { xs: 'center', sm: 'space-between' },
      alignItems: { xs: 'center', sm: 'center' },
      gap: 1,
      p: 0,
      textAlign: { xs: 'center', sm: 'left' },
    }}
  >
    <Typography variant="h5">
      {props.nomBureau} - {props.quartierBureau}
    </Typography>

    <Typography
      variant="body1"
      sx={{ color: 'text.primary' }}
    >
      Nos cours de change de devises
    </Typography>
  </CardContent>
</Card>


      <Stack
        direction={"row"}
        spacing={4}
        useFlexGap
        flexWrap="wrap"
        justifyContent="center" // Centrer les éléments enfants horizontalement
        alignItems="endcenter" // Centrer les éléments enfants verticalement
        sx={{
          borderRadius: 2,
          padding: 2,
        }}
      >
        {props?.cours?.map((cour) => (
          <Card
            key={cour.id}
            sx={{
              width: 320,
              // height: 232,
              textAlign: "center",
              backgroundColor: "goldenrod",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // ✅ petite ombre élégante
              borderRadius: 2,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)", // léger agrandissement au survol
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)", // ombre plus forte au hover
              },
            }}
          >
            <Stack direction="row">
              <CardContent>
                <img
                  src={`${process.env.REACT_APP_BASE_FILE_URL}/Devise/image/${cour.devise.image}`}
                  alt={`${cour.devise.pays}`}
                  style={{ borderRadius: 4, width: 132 }}
                />
                <Typography variant="body1" sx={{ mt: 1 }}>
                  {cour.devise.pays}
                </Typography>
              </CardContent>

              <CardContent
                sx={{ backgroundColor: "white", margin: 1, borderRadius: 2 }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ color: "black" }}
                >
                  Vous achetez
                </Typography>
                <Typography color="text.secondary" variant="body2">
                  1 {cour.devise.name} à {Number(cour.prixVente).toFixed(2)} MAD
                </Typography>
                <Divider />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ color: "black" }}
                >
                  Vous vendez
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  1 {cour.devise.name} à {Number(cour.prixAchat).toFixed(2)} MAD
                </Typography>
              </CardContent>
            </Stack>
            <Stack direction="row" justifyContent="center" alignItems="end">
              <CardActions>
                <Button
                  size="small"
                  sx={{
                    backgroundColor: "black",
                    color: "yellow",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                  onClick={() => {
                    // dispatcher le cours, le taux et typeOperation dans le store

                    navigate(
                      `/reservation/simulatorachat/${cour.devise_id}/${cour.bureau_id}`
                    );
                  }}
                >
                  J'achète
                </Button>
              </CardActions>
              <CardActions>
                <Button
                  size="small"
                  sx={{
                    backgroundColor: "black",
                    color: "yellow",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                  onClick={() => {
                    navigate(
                      `/reservation/simulatorvente/${cour.devise_id}/${cour.bureau_id}`
                    );
                  }}
                >
                  Je vends
                </Button>
              </CardActions>
            </Stack>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}

export default CoursCard;
